export const EmojiDefault = () => {
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3587 5.5C9.21871 5.5 5.86621 8.86 5.86621 13C5.86621 17.14 9.21871 20.5 13.3587 20.5C17.5062 20.5 20.8662 17.14 20.8662 13C20.8662 8.86 17.5062 5.5 13.3587 5.5ZM10.7412 10C11.3637 10 11.8662 10.5025 11.8662 11.125C11.8662 11.7475 11.3637 12.25 10.7412 12.25C10.1187 12.25 9.61621 11.7475 9.61621 11.125C9.61621 10.5025 10.1187 10 10.7412 10ZM13.3662 17.5C11.6562 17.5 10.2012 16.255 9.61621 14.5H17.1162C16.5312 16.255 15.0762 17.5 13.3662 17.5ZM15.9912 12.25C15.3687 12.25 14.8662 11.7475 14.8662 11.125C14.8662 10.5025 15.3687 10 15.9912 10C16.6137 10 17.1162 10.5025 17.1162 11.125C17.1162 11.7475 16.6137 12.25 15.9912 12.25Z"
        fill="white"
      />
      <circle cx="13.3662" cy="13" r="12.5" stroke="white" />
    </svg>
  );
};

export const MuteSVG = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 6.99993L15 12.9999M15 6.99993L21 12.9999M8.63432 2.36561L5.46863 5.5313C5.29568 5.70425 5.2092 5.79073 5.10828 5.85257C5.01881 5.9074 4.92127 5.9478 4.81923 5.9723C4.70414 5.99993 4.58185 5.99993 4.33726 5.99993H2.6C2.03995 5.99993 1.75992 5.99993 1.54601 6.10892C1.35785 6.20479 1.20487 6.35777 1.10899 6.54594C1 6.75985 1 7.03987 1 7.59993V12.3999C1 12.96 1 13.24 1.10899 13.4539C1.20487 13.6421 1.35785 13.7951 1.54601 13.8909C1.75992 13.9999 2.03995 13.9999 2.6 13.9999H4.33726C4.58185 13.9999 4.70414 13.9999 4.81923 14.0276C4.92127 14.0521 5.01881 14.0925 5.10828 14.1473C5.2092 14.2091 5.29568 14.2956 5.46863 14.4686L8.63431 17.6342C9.06269 18.0626 9.27688 18.2768 9.46077 18.2913C9.62033 18.3038 9.77626 18.2392 9.8802 18.1175C10 17.9773 10 17.6744 10 17.0686V2.9313C10 2.32548 10 2.02257 9.8802 1.88231C9.77626 1.76061 9.62033 1.69602 9.46077 1.70858C9.27688 1.72305 9.06269 1.93724 8.63432 2.36561Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UnMuteSVG = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7479 1.99993C20.1652 3.97016 21 6.38756 21 8.99993C21 11.6123 20.1652 14.0297 18.7479 15.9999M14.7453 4.99993C15.5362 6.13376 16 7.51268 16 8.99993C16 10.4872 15.5362 11.8661 14.7453 12.9999M8.63432 2.36561L5.46863 5.5313C5.29568 5.70425 5.2092 5.79073 5.10828 5.85257C5.01881 5.9074 4.92127 5.9478 4.81923 5.9723C4.70414 5.99993 4.58185 5.99993 4.33726 5.99993H2.6C2.03995 5.99993 1.75992 5.99993 1.54601 6.10892C1.35785 6.20479 1.20487 6.35777 1.10899 6.54594C1 6.75985 1 7.03987 1 7.59993V10.3999C1 10.96 1 11.24 1.10899 11.4539C1.20487 11.6421 1.35785 11.7951 1.54601 11.8909C1.75992 11.9999 2.03995 11.9999 2.6 11.9999H4.33726C4.58185 11.9999 4.70414 11.9999 4.81923 12.0276C4.92127 12.0521 5.01881 12.0925 5.10828 12.1473C5.2092 12.2091 5.29568 12.2956 5.46863 12.4686L8.63431 15.6342C9.06269 16.0626 9.27688 16.2768 9.46077 16.2913C9.62033 16.3038 9.77626 16.2392 9.8802 16.1175C10 15.9773 10 15.6744 10 15.0686V2.9313C10 2.32548 10 2.02257 9.8802 1.88231C9.77626 1.76061 9.62033 1.69602 9.46077 1.70858C9.27688 1.72305 9.06269 1.93724 8.63432 2.36561Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
